<!--
/*
 * This file is part of OrangeHRM Inc
 *
 * Copyright (C) 2020 onwards OrangeHRM Inc
 *
 * This program is free software; you can redistribute it and/or modify
 * it under the terms of the GNU General Public License as published by
 * the Free Software Foundation; either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program.  If not, see  http://www.gnu.org/licenses
 */
-->

<template>
  <g>
    <path
      class="cls-1"
      d="M 179.221 364.865 C 317.967 364.899 407.751 218.243 344.676 94.595 L 415.585 94.595 C 462.216 94.595 500 132.399 500 179.054 L 500 297.298 L 398.702 297.298 C 342.751 297.298 297.403 342.669 297.403 398.649 L 297.403 500 L 179.221 500 C 132.59 500 94.806 462.196 94.806 415.541 L 94.806 344.595 C 120.941 357.906 149.879 364.865 179.221 364.865 Z"
    />
    <path
      class="cls-1"
      d="M 331.169 500 C 342.042 498.582 352.138 493.615 359.87 485.811 L 485.143 360.473 C 493.315 352.669 498.548 342.298 500 331.081 L 398.702 331.081 C 361.39 331.081 331.169 361.318 331.169 398.649 L 331.169 500 Z"
    />
    <path
      class="cls-1"
      d="M 165.715 0 C 38.349 0 -41.272 137.939 22.411 248.311 C 86.094 358.683 245.336 358.683 309.019 248.311 C 323.538 223.142 331.169 194.595 331.169 165.541 C 330.798 74.257 256.951 0.372 165.715 0 Z M 215.351 182.095 L 165.715 182.095 C 156.429 182.5 148.764 174.831 149.169 165.541 L 149.169 82.77 C 149.169 69.764 163.25 61.655 174.494 68.142 C 179.728 71.149 182.936 76.723 182.936 82.77 L 182.936 150.338 L 216.702 150.338 C 229.702 150.338 237.806 164.426 231.323 175.676 C 228.317 180.912 222.746 184.122 216.702 184.122 L 215.351 182.095 Z"
    />
  </g>
</template>
